import { getErrorPayload } from '@application/common/helpers/api-helper';
import AuthApi from '@infrastructure/auth-api';
import LocalStorageService from '@infrastructure/local-storage-service';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { addErrorNotification, addSuccessNotification } from '../common/notificationSlice';
export const loginAsync = createAsyncThunk('auth/login', async (credentials, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AuthApi.login(credentials);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const refreshTokenAsync = createAsyncThunk('auth/refreshToken', async (_, { rejectWithValue }) => {
    try {
        const refreshTokenRequest = {
            accessToken: LocalStorageService.getAccessToken(),
            refreshToken: LocalStorageService.getRefreshToken()
        };
        const response = await AuthApi.getRefreshToken(refreshTokenRequest);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const signUpAsync = createAsyncThunk('auth/signUp', async (user, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AuthApi.signUp(user);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const confirmEmailAsync = createAsyncThunk('auth/confirmEmail', async (confirmation, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AuthApi.confirmEmail(confirmation);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const forgotPasswordAsync = createAsyncThunk('auth/forgotPassword', async (input, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AuthApi.forgotPassword(input);
        dispatch(addSuccessNotification('Wachtwoord vergeten e-mail verzonden op de betreffende e-mail'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const changePasswordAsync = createAsyncThunk('auth/changePassword', async (input, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AuthApi.changePassword(input);
        dispatch(addSuccessNotification('Wachtwoord succesvol veranderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const verifyTokenAsync = createAsyncThunk('auth/verifyToken', async (VerifyTokenDto, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AuthApi.verifyToken(VerifyTokenDto);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllEmployeesAsync = createAsyncThunk('account/getAllEmployees', async (_, { rejectWithValue }) => {
    try {
        const response = await AuthApi.getAllEmployees();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUserByIdAsync = createAsyncThunk('account/GetUserById', async (userId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AuthApi.getUserById(userId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllUserRolesAsync = createAsyncThunk('account/GetAllRoles', async (_, { rejectWithValue }) => {
    try {
        const response = await AuthApi.getAllUserRoles();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createUserAsync = createAsyncThunk('account/RegisterEmployee', async (user, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AuthApi.createUser(user);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateUserAsync = createAsyncThunk('account/UpdateEmployee', async (user, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AuthApi.updateUser(user);
        dispatch(addSuccessNotification('Gebruiker succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateEmployeeStatusAsync = createAsyncThunk('account/updateEmployeeStatus', async (employeeStatus, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AuthApi.updateEmployeeStatus(employeeStatus);
        if (response.data) {
            dispatch(addSuccessNotification('Werknemerstatus succesvol bijgewerkt.'));
        }
        else {
            dispatch(addErrorNotification('Medewerkerstatus bijwerken is mislukt.'));
        }
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateRoleStatusAsync = createAsyncThunk('account/updateRoleStatus', async (roleStatus, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AuthApi.updateRoleStatus(roleStatus);
        if (response.data) {
            dispatch(addSuccessNotification('Rolstatus succesvol bijgewerkt.'));
        }
        else {
            dispatch(addErrorNotification('Rollenstatusupdate mislukt.'));
        }
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const resetPasswordAsync = createAsyncThunk('auth/resetPassword', async (input, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AuthApi.resetPassword(input);
        dispatch(addSuccessNotification('Wachtwoord succesvol veranderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getWorkshopLocationAsync = createAsyncThunk('auth/workshoplocation', async (_, { rejectWithValue }) => {
    try {
        const response = await AuthApi.getWorkshopLocation();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEmployeesByRoleCategory = createAsyncThunk('account/getEmployeesByRoleCategory', async (_, { rejectWithValue }) => {
    try {
        const response = await AuthApi.getEmployeesByRoleCategory();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEmployeeSettingsAsync = createAsyncThunk('account/getEmployeeSettings', async (userId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AuthApi.getEmployeeSettingsByEmployeeId(userId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createEmployeeSettingsAsync = createAsyncThunk('account/createEmployeeSettings', async (employeeSettings, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AuthApi.createEmployeeSettings(employeeSettings);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
